var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_vm.hasAnyPermission(['goodsreceipt.create']) ? _c('b-row', [_c('b-col', {
    staticClass: "mb-4"
  }, [_c('OmniCard', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('OmniCardTitle', {
          staticClass: "mb-0"
        }, [_vm._v(" Acties ")])];
      },
      proxy: true
    }], null, false, 1042087897)
  }, [_c('OmniButtonCollection', [_vm.hasPermission('goodsreceipt.create') ? _c('OmniButton', {
    attrs: {
      "to": {
        name: 'GoodsReceiptCreate'
      }
    }
  }, [_vm._v(" Goederenontvangst aanmaken ")]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    staticClass: "mb-4"
  }, [_c('OmniCard', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('OmniCardTitle', {
          staticClass: "mb-0"
        }, [_vm._v(" FILTERS ")])];
      },
      proxy: true
    }])
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("Afzender / leverancier")]), _c('br'), _c('b-select', {
    attrs: {
      "options": _vm.vendors,
      "text-field": "display_name",
      "value-field": "id",
      "autocomplete": "off"
    },
    model: {
      value: _vm.filterForm.supplier_location_id,
      callback: function ($$v) {
        _vm.$set(_vm.filterForm, "supplier_location_id", $$v);
      },
      expression: "filterForm.supplier_location_id"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("Is voltooid")]), _c('br'), _c('b-select', {
    attrs: {
      "options": _vm.isCompletedOptions,
      "autocomplete": "off"
    },
    model: {
      value: _vm.filterForm.is_completed,
      callback: function ($$v) {
        _vm.$set(_vm.filterForm, "is_completed", $$v);
      },
      expression: "filterForm.is_completed"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-card', [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.results')))]), _vm.isFetchingGoodsReceipts ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : !_vm.goodsReceipts.length ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_vm._v(" Geen goederenontvangsten gevonden. ")]) : _c('b-table-simple', [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "200px"
    }
  }), _c('col', {
    staticStyle: {
      "width": "200px"
    }
  }), _c('col', {
    staticStyle: {
      "width": "200px"
    }
  }), _c('col'), _vm._l(_vm.goodsReceipts[0].total_lines_attribute_count, function () {
    return _c('col');
  })], 2), _c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("Aangemaakt op")]), _c('b-th', [_vm._v("Afzender")]), _c('b-th', [_vm._v("Identifier")]), _c('b-th', [_vm._v("Voltooid")]), _c('b-th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Aantal crossdock-artikelen")]), _vm._l(_vm.goodsReceipts[0].total_lines_attribute_count, function (count, attribute) {
    return _c('b-th', {
      staticClass: "text-nowrap"
    }, [_vm._v(" Aantal " + _vm._s(_vm._f("toText")(attribute)) + " "), _c('font-awesome-icon', {
      directives: [{
        name: "b-popover",
        rawName: "v-b-popover.hover.top",
        value: 'Wordt gevuld bij het aanmaken van de goederenontvangst en daarna niet meer geüpdatet.',
        expression: "'Wordt gevuld bij het aanmaken van de goederenontvangst en daarna niet meer geüpdatet.'",
        modifiers: {
          "hover": true,
          "top": true
        }
      }],
      staticClass: "text-info ml-2",
      attrs: {
        "icon": "circle-info"
      }
    })], 1);
  })], 2)], 1), _c('b-tbody', _vm._l(_vm.goodsReceipts, function (goodsReceipt) {
    return _c('b-tr', {
      key: goodsReceipt.id
    }, [_c('b-td', [_vm._v(_vm._s(_vm._f("datetimeshort")(goodsReceipt.created_at)))]), _c('b-td', [_c('location-link', {
      attrs: {
        "location": goodsReceipt.supplier_location
      }
    })], 1), _c('b-td', [_c('b-link', {
      attrs: {
        "to": _vm.getGoodsReceiptRoute(goodsReceipt)
      }
    }, [_vm._v(_vm._s(goodsReceipt.identifier))])], 1), _c('b-td', [_vm._v(" " + _vm._s(goodsReceipt.is_completed ? 'Ja' : 'Nee') + " ")]), _c('b-td', [_vm._v(" " + _vm._s(goodsReceipt.total_lines_crossdock_count) + " ")]), _vm._l(goodsReceipt.total_lines_attribute_count, function (count, attribute) {
      return _c('b-td', [_vm._v(" " + _vm._s(count) + " ")]);
    })], 2);
  }), 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }